import { render, staticRenderFns } from "./EvenementModal.vue?vue&type=template&id=193bf23e"
import script from "./EvenementModal.vue?vue&type=script&lang=ts"
export * from "./EvenementModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports